import { SurfboardPaymentResultEnum } from '../../enum/surfboard';

export interface SurfboardTransactionDetail {
  transactionId: string;
  terminalId: string;
  rrn: string;
  amount: string;
  currency: string;
  method: string;
  voided: boolean;
  truncatedPan?: string; // Optional as not always present (e.g. if the original object didn't include it or if the method isn't CARD)
  cardLabel?: string | null;
  posEntryMode: string;
  aid: string | null;
  customerResponseCode: string;
  cvmMethodDescription?: string;
  authMode: string;
  cardBrand?: string;
  terminalVerificationResult: string | null;
  customerResponseDescription: string;
}

export interface SurfboardAdjustmentApplied {
  adjustmentType: string;
  amount: string;
}

export interface SurfboardEventMetadata {
  eventId: string;
  created: number;
  retryAttempt: number;
  terminalId: string;
  originalCreated: number;
  webhookEventId: string;
}

// New interface for transaction details in failed/cancelled events
export interface SurfboardEventDetail {
  paymentId: string;
  terminalId: string;
  rrn: string;
  amount: number | string;
  currency: string;
  method: string;
  cardLabel: string;
  posEntryMode: string;
  aid: string | null;
  cardBrand: string;
  terminalVerificationResult: string;
  customerResponseDescription: string;
}

export interface SurfboardOrderEventData {
  orderId: string;
  paymentStatus?: string; // Made optional as it's missing in the top-level data for FAILED/CANCELLED events
  orderStatus?: SurfboardPaymentResultEnum;
  paymentMethod?: string; // Made optional as it's missing in the top-level data for FAILED/CANCELLED events
  paymentId: string;
  merchantId: string;
  referenceId: string;
  adjustments: SurfboardAdjustmentApplied[];
  truncatedPan?: string;
  amount?: string;
  type?: string;
  transactionDetails?: SurfboardTransactionDetail[];

  metadata: {
    [key: string]: any; // Using 'any' to accommodate both key/value pairs and the array-of-objects structure
  };

  failedTransactionDetails?: SurfboardEventDetail;
  cancelledTransactionDetails?: SurfboardEventDetail;
}

export interface SurfboardWebhookOrderEvent {
  eventType: 'order.paymentinitiated' | 'order.paymentprocessed' | 'order.paymentcompleted' | 'order.paymentfailed' | 'order.paymentcancelled' | string;
  metadata: SurfboardEventMetadata;
  data: SurfboardOrderEventData;
}

